import { render, staticRenderFns } from "./RightSideNavigation.vue?vue&type=template&id=0d470c12&scoped=true&"
import script from "./RightSideNavigation.vue?vue&type=script&lang=js&"
export * from "./RightSideNavigation.vue?vue&type=script&lang=js&"
import style0 from "./RightSideNavigation.vue?vue&type=style&index=0&id=0d470c12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d470c12",
  null
  
)

export default component.exports